import { Box, useToast } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useForm } from 'react-hook-form'
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
} from '@chakra-ui/react'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'
import { user } from '../../../helpers/user'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

const schema = z.object({
  numero_pedido: z.string().nonempty('Campo obrigatório'),
  email_titular_cartao: z.string().email('E-mail inválido'),
  nome_titular_cartao: z.string().nonempty('Campo obrigatório'),
  codigo_usuario: z.string().nonempty('Campo obrigatório'),
})

async function liberarCartaoRecusado({
  numeroPedido,
  codigoUsuario,
  emailTitular,
  nomeTitular,
}) {
  const response = await api.post('/pagamento/negado', {
    numero_pedido: numeroPedido,
    codigo_usuario: codigoUsuario,
    email_titular_cartao: emailTitular,
    nome_titular_cartao: nomeTitular,
  })

  return response.data
}

export function LiberacaoCartaoRecusado() {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const { mutateAsync, isLoading: isSubmitting } = useMutation({
    mutationFn: (values) =>
      liberarCartaoRecusado({
        numeroPedido: values.numero_pedido,
        codigoUsuario: user.codigo_usuario,
        emailTitular: values.email_titular_cartao,
        nomeTitular: values.nome_titular_cartao,
      }),
    onSuccess: () => {
      toast({
        title: 'Sucesso',
        description: 'E-mail enviado com sucesso',
        status: 'success',
      })

      reset()
    },
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro ao enviar e-mail',
        status: 'error',
      })
    },
  })

  async function onSubmit(values) {
    await mutateAsync(values)
  }

  return (
    <>
      <HeadingPages name="Liberação de Cartão Recusado" />
      <Box maxW="1300px" mx="auto" w="100%">
        <Box
          as="form"
          w="100%"
          maxW="600px"
          mx="auto"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            type="hidden"
            {...register('codigo_usuario')}
            value={user.codigo_usuario}
          />
          <FormControl isInvalid={errors.numero_pedido} mt={4}>
            <FormLabel
              htmlFor="numero_pedido"
              fontSize="sm"
              fontWeight="bold"
              color="gray.600"
            >
              Número do Pedido
            </FormLabel>
            <Input
              id="numero_pedido"
              placeholder="Digite o Número do Pedido"
              {...register('numero_pedido')}
            />
            <FormErrorMessage>
              {errors.numero_pedido && errors.numero_pedido.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.nome_titular_cartao} mt={4}>
            <FormLabel
              htmlFor="nome_titular_cartao"
              fontSize="sm"
              fontWeight="bold"
              color="gray.600"
            >
              Nome do Titular
            </FormLabel>
            <Input
              id="nome_titular_cartao"
              placeholder="Digite o Nome do Titular"
              {...register('nome_titular_cartao')}
            />
            <FormErrorMessage>
              {errors.nome_titular_cartao && errors.nome_titular_cartao.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.email_titular_cartao} mt={4}>
            <FormLabel
              htmlFor="email_titular_cartao"
              fontSize="sm"
              fontWeight="bold"
              color="gray.600"
            >
              Email do Titular
            </FormLabel>
            <Input
              id="email_titular_cartao"
              placeholder="Digite o Nome do Titular"
              {...register('email_titular_cartao')}
            />
            <FormErrorMessage>
              {errors.email_titular_cartao &&
                errors.email_titular_cartao.message}
            </FormErrorMessage>
          </FormControl>

          <Button
            mt={4}
            colorScheme="blue"
            isLoading={isSubmitting}
            type="submit"
          >
            Enviar
          </Button>
        </Box>
      </Box>
    </>
  )
}
